import React from 'react'
import { Helmet } from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import { AudioObject, VideoObject } from 'schema-dts'
import { MediaSchema as MediaSchemaType } from '../../types/media'

interface Props {
  mediaSchema: MediaSchemaType
}

const MediaSEO: React.FC<Props> = ({ mediaSchema }) => {
  const isAudio =
    mediaSchema.contentUrl?.includes('soundcloud') ||
    mediaSchema.contentUrl?.includes('mixcloud')

  if (mediaSchema.contentUrl && isAudio) {
    return (
      <Helmet
        script={[
          helmetJsonLdProp<AudioObject>({
            '@context': 'https://schema.org',
            '@type': 'AudioObject',
            name: mediaSchema.name ? mediaSchema.name : 'Audio',
            description: mediaSchema.description
              ? mediaSchema.description
              : 'Audio',
            thumbnailUrl: mediaSchema.thumbnailUrl
              ? mediaSchema.thumbnailUrl
              : '',
            uploadDate: mediaSchema.uploadDate ? mediaSchema.uploadDate : '',
            contentUrl: mediaSchema.contentUrl,
            transcript: mediaSchema.transcript
              ? mediaSchema.transcript
              : 'No transcript',
          }),
        ]}
      />
    )
  }

  if (mediaSchema.contentUrl) {
    return (
      <Helmet
        script={[
          helmetJsonLdProp<VideoObject>({
            '@context': 'https://schema.org',
            '@type': 'VideoObject',
            name: mediaSchema.name ? mediaSchema.name : 'Video',
            description: mediaSchema.description
              ? mediaSchema.description
              : 'Video',
            thumbnailUrl: mediaSchema.thumbnailUrl
              ? mediaSchema.thumbnailUrl
              : '',
            uploadDate: mediaSchema.uploadDate ? mediaSchema.uploadDate : '',
            contentUrl: mediaSchema.contentUrl,
            transcript: mediaSchema.transcript
              ? mediaSchema.transcript
              : 'No transcript',
          }),
        ]}
      />
    )
  }

  return null
}

export default MediaSEO
